module.exports = __webpack_public_path__ + "img/placeholder-info.c50c2859.svg";